// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".5250c9a17ff696d58b7695c2b4b59e3a.js";
};